import React, { useMemo } from 'react';
import { NuvoGrid } from '@nuvolo/nuux-core/components/NuvoGrid';
import type { RecordPreviewProps } from './RecordPreviewProps';
import Styles from './Styles';
import deepMapChildren from '#/common/utils/deepMapChildren';
import renderItems from './renderItems';
import mapFieldItems from './mapFieldItems';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import { useNavigate } from 'react-router-dom';

const RecordPreview = <T,>({
  record,
  title,
  fields = [],
  noBorder,
  noPadding,
}: RecordPreviewProps<T>) => {
  const navigate = useNavigate();
  const fieldItems = useMemo(() => {
    const items = mapFieldItems(fields, record, navigate);
    const newItems = deepMapChildren(items, (item) => item);

    return newItems;
  }, [fields, record, navigate]);

  return (
    <Styles $noBorder={noBorder} $noPadding={noPadding}>
      {!!title && <div className="record-preview-title">{title}</div>}
      <NuvoGrid container wrap="wrap">
        {renderItems(fieldItems)}
      </NuvoGrid>
    </Styles>
  );
};

export default React.memo(RecordPreview);
